export default {
    mvpIntro: '本节课的MVP是~',
    buttons: {
        show: '查看',
    },
};
